// extracted by mini-css-extract-plugin
export default {"inner":"Browse_inner__IVbe5","head":"Browse_head__g+1Ow","headSmall":"Browse_headSmall__OGeN6","info":"Browse_info__XKo8D","wrapper":"Browse_wrapper__wVYK5"};